// Initiatives.jsx - Compact Version
import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Initiatives.css";

const Initiatives = () => {
  const [filter, setFilter] = useState("all");
  const [expanded, setExpanded] = useState(null);

  const initiatives = [
    {
      id: 1,
      title: "Digital Transformation",
      category: "technology",
      icon: "💻",
      status: "In Progress",
      progress: 75,
      desc: "Digitizing government services for transparency and efficiency.",
      details: [
        "Online complaint system",
        "Digital verification",
        "E-governance",
      ],
      impact: "85% faster processing",
    },
    {
      id: 2,
      title: "Healthcare Development",
      category: "healthcare",
      icon: "🏥",
      status: "In Progress",
      progress: 60,
      desc: "Building healthcare facilities across KP.",
      details: ["50 new health units", "10 hospital upgrades", "Telemedicine"],
      impact: "Serving 2M+ citizens",
    },
    {
      id: 3,
      title: "Agricultural Revolution",
      category: "agriculture",
      icon: "🌾",
      status: "Completed",
      progress: 100,
      desc: "Modernizing agriculture with tech and farmer support.",
      details: ["AgriGIS mapping", "Farmer training", "Kissan Bazar"],
      impact: "40% crop yield increase",
    },
    {
      id: 4,
      title: "Education Reforms",
      category: "education",
      icon: "📚",
      status: "In Progress",
      progress: 45,
      desc: "Quality education and skill development.",
      details: ["Smart classrooms", "Teacher training", "IT labs"],
      impact: "100K+ students benefited",
    },
    {
      id: 5,
      title: "Infrastructure Development",
      category: "infrastructure",
      icon: "🛣️",
      status: "In Progress",
      progress: 55,
      desc: "Building roads and infrastructure.",
      details: ["500 km roads", "100 bridges", "Urban development"],
      impact: "40% travel time reduction",
    },
    {
      id: 6,
      title: "Clean Energy",
      category: "energy",
      icon: "⚡",
      status: "Upcoming",
      progress: 20,
      desc: "Promoting renewable energy solutions.",
      details: ["Solar panels", "Micro-hydro", "Wind energy"],
      impact: "Target: 500 MW",
    },
  ];

  const categories = [
    { id: "all", label: "All" },
    { id: "technology", label: "Tech" },
    { id: "healthcare", label: "Health" },
    { id: "agriculture", label: "Agri" },
    { id: "education", label: "Edu" },
    { id: "infrastructure", label: "Infra" },
    { id: "energy", label: "Energy" },
  ];

  const filtered =
    filter === "all"
      ? initiatives
      : initiatives.filter((i) => i.category === filter);

  const getStatusColor = (status) => {
    const colors = {
      Completed: "#27ae60",
      "In Progress": "#f39c12",
      Upcoming: "#3498db",
    };
    return colors[status] || "#95a5a6";
  };

  return (
    <div className="initiatives-page">
      {/* Hero */}
      <div className="hero">
        <h1>🏛️ Minister's Initiatives</h1>
        <p>Transformative projects for Khyber Pakhtunkhwa's progress.</p>
        <div className="stats">
          <span>
            <strong>8</strong> Initiatives
          </span>
          <span>
            <strong>6</strong> Sectors
          </span>
          <span>
            <strong>5M+</strong> Beneficiaries
          </span>
        </div>
      </div>

      {/* Filters */}
      <div className="filters">
        {categories.map((cat) => (
          <button
            key={cat.id}
            className={filter === cat.id ? "active" : ""}
            onClick={() => setFilter(cat.id)}
          >
            {cat.label}
          </button>
        ))}
      </div>

      {/* Grid */}
      <div className="grid">
        {filtered.map((init) => (
          <div key={init.id} className="card">
            <div className="card-top">
              {/* <span className="icon">{init.icon}</span> */}
              <div>
                <h3>{init.title}</h3>
                <span
                  className="status"
                  style={{ background: getStatusColor(init.status) }}
                >
                  {init.status}
                </span>
              </div>
            </div>

            <p className="desc">{init.desc}</p>

            <div className="progress">
              <span>Progress {init.progress}%</span>
              <div className="bar">
                <div style={{ width: `${init.progress}%` }} />
              </div>
            </div>

            <div className="impact">{init.impact}</div>

            {expanded === init.id && (
              <ul className="details">
                {init.details.map((d, i) => (
                  <li key={i}>▸ {d}</li>
                ))}
              </ul>
            )}

            <button
              className="toggle"
              onClick={() => setExpanded(expanded === init.id ? null : init.id)}
            >
              {expanded === init.id ? "▲ Less" : "▼ More"}
            </button>
          </div>
        ))}
      </div>

      {/* CTA */}
      <div className="cta">
        <h2>💡 Have an Idea?</h2>
        <Link to="/submit-suggestion" className="btn">
          Submit Suggestion
        </Link>
      </div>
    </div>
  );
};

export default Initiatives;
